export class CampEntity {
    id: string=""
    name: string=""
    country: string=""
    email: boolean=false
    intranetAccessProfile: string=""
}

